define('cartware_checkout/components/advises/regionUpdater',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/dom/event/trigger"
], function(
	$,
	_,
	Component,
	triggerEvent
) {
	return Component.create({
		$init: function() {
			window.shippingRegionUpdater.update();
			window.billingRegionUpdater.update();
		},

		init: function() {
			var _update = RegionUpdater.prototype.update;
			RegionUpdater.prototype.update = function() {
				_update.apply(this, arguments);

				triggerEvent(this.regionSelectEl, "change");
			};

			RegionUpdater.prototype.setMarkDisplay = _.wrap(RegionUpdater.prototype.setMarkDisplay, function(parent, select, display) {
				parent(select, display);

				var select2 = $(select).data("select2");
				if (select2) {
					select2.$container.css("display", display ? "" : "none");
				}
			});

			RegionUpdater.prototype.update = _.wrap(RegionUpdater.prototype.update, function(parent) {
				var select = this.regionSelectEl,
					$select = $(select),
					select2 = $select.data("select2");

				parent.call(this);

				if (select2) {
					select2.$container.css("display", select.style.display === "none" ? "none" : "");
				}
			});
		}
	});
});
